import { render, staticRenderFns } from "./IntegralShop.vue?vue&type=template&id=eb52f85a&scoped=true&"
import script from "./IntegralShop.vue?vue&type=script&lang=js&"
export * from "./IntegralShop.vue?vue&type=script&lang=js&"
import style0 from "./IntegralShop.vue?vue&type=style&index=0&id=eb52f85a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb52f85a",
  null
  
)

export default component.exports